import { __assign } from 'tslib';
import { number } from 'style-value-types';
var _int = __assign(__assign({}, number), {
  transform: Math.round
});
export { _int as int };